// removed by extract-text-webpack-plugin
module.exports = {"Loader":"styles__Loader___1H3bN","loader10":"styles__loader10___eCK19","Logo":"styles__Logo___2hfY4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientCollection/Loader/styles.scss
// module id = 1386
// module chunks = 0